import {Clock} from 'lucide-react'
import { useEffect, useState } from 'react'
import { getProjectCountdownLabel } from '@/lib/format'

interface PresaleEndsCountdownProps {
  endsAt?: string
  startsAt?: string
  status?: string
  className?: string
  withIcon?: boolean
}

function useNow(intervalMs = 1000) {
  const [now, setNow] = useState(() => Date.now())

  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), intervalMs)
    return () => window.clearInterval(id)
  }, [intervalMs])

  return now
}

function PresaleEndsCountdown({
  endsAt,
  startsAt,
  status,
  className,
  withIcon = false,
}: PresaleEndsCountdownProps) {
  const now = useNow()
  if (!endsAt && !startsAt)
    return null

  const label = getProjectCountdownLabel({
    type: 'presale',
    status: status || 'live',
    startsAt,
    endsAt: endsAt || '',
  }, now)

  if (!label)
    return null

  if (!withIcon)
    return <span className={className} aria-live="polite">{label}</span>

  return (
    <span className={className} aria-live="polite">
      <Clock className="h-3.5 w-3.5" aria-hidden="true" />
      {label}
    </span>
  )
}

export default PresaleEndsCountdown
